/**
 * APP订制
 * $t('enum.E_AppCustoms.SPOT_CHECK')
 * $t('enum.E_AppCustoms.PLATFORM_REMOTE')
 * $t('enum.E_AppCustoms.VIP')
 * $t('enum.E_AppCustoms.OEM')
 */
export enum E_AppCustoms {
    /**
     * 点巡检
     */
    SPOT_CHECK,
    /**
     * 平台远程
     */
    PLATFORM_REMOTE,
    /**
     * 
     */
    VIP,
    /**
     * 贴牌
     */
    OEM,
}

export const AppCustomMenuMap = {
    [E_AppCustoms.SPOT_CHECK]: [
        ['app:platform', false],
        ['app:platform:summary', false],
        ['app:platform:mapping', false],

        ['app:spot_check', true],
        ['app:spot_check:task', true],
        ['app:spot_check:to_hidden_danger', false],
        ['app:spot_check:direct_link', true],

        ['app:manager', true],
        ['app:manager:finished', true],
        ['app:manager:timeout', true],
        ['app:manager:hidden_danger', false],
        ['app:manager:repair', false],
        ['app:manager:upkeep', false],
        ['app:manager:diagnostic_notification', false],
        ['app:manager:alarm_notification', false],

        ['app:consult', false],
        ['app:consult:recommend', false],
        ['app:consult:news', false],

        ['app:my', true],
        ['app:my:about_us', true],
        ['app:my:languages', true],
        ['app:my:check_update', true],
    ],
    [E_AppCustoms.PLATFORM_REMOTE]: [
        ['app:platform', true],
        ['app:platform:summary', true],
        ['app:platform:mapping', true],

        ['app:spot_check', false],
        ['app:spot_check:task', false],
        ['app:spot_check:to_hidden_danger', false],
        ['app:spot_check:direct_link', false],

        ['app:manager', true],
        ['app:manager:finished', false],
        ['app:manager:timeout', false],
        ['app:manager:hidden_danger', false],
        ['app:manager:repair', false],
        ['app:manager:upkeep', false],
        ['app:manager:diagnostic_notification', true],
        ['app:manager:alarm_notification', true],

        ['app:consult', true],
        ['app:consult:recommend', true],
        ['app:consult:news', true],

        ['app:my', true],
        ['app:my:about_us', true],
        ['app:my:languages', true],
        ['app:my:check_update', true],
    ],
    [E_AppCustoms.VIP]: [
        ['app:platform', true],
        ['app:platform:summary', true],
        ['app:platform:mapping', true],

        ['app:spot_check', true],
        ['app:spot_check:task', true],
        ['app:spot_check:to_hidden_danger', true],
        ['app:spot_check:direct_link', true],

        ['app:manager', true],
        ['app:manager:finished', true],
        ['app:manager:timeout', true],
        ['app:manager:hidden_danger', true],
        ['app:manager:repair', true],
        ['app:manager:upkeep', true],
        ['app:manager:diagnostic_notification', true],
        ['app:manager:alarm_notification', true],

        ['app:consult', true],
        ['app:consult:recommend', true],
        ['app:consult:news', true],

        ['app:my', true],
        ['app:my:about_us', true],
        ['app:my:languages', true],
        ['app:my:check_update', true],
    ],
    [E_AppCustoms.OEM]: [
        ['app:platform', true],
        ['app:platform:summary', true],
        ['app:platform:mapping', true],

        ['app:spot_check', true],
        ['app:spot_check:task', true],
        ['app:spot_check:to_hidden_danger', true],
        ['app:spot_check:direct_link', true],

        ['app:manager', true],
        ['app:manager:finished', true],
        ['app:manager:timeout', true],
        ['app:manager:hidden_danger', true],
        ['app:manager:repair', true],
        ['app:manager:upkeep', true],
        ['app:manager:diagnostic_notification', true],
        ['app:manager:alarm_notification', true],

        ['app:consult', false],
        ['app:consult:recommend', false],
        ['app:consult:news', false],

        ['app:my', true],
        ['app:my:about_us', true],
        ['app:my:languages', true],
        ['app:my:check_update', true],
    ],
}

export function getCustomAppMenu(custom: E_AppCustoms) {
    return AppCustomMenuMap[custom]
}
